module.exports = __webpack_public_path__ + "static/img/3.2f44288.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/3.png
// module id = lKnX
// module chunks = 0